import { useEffect } from 'react'


/**
 * Used to tell whether or not a User Action was preformed within the bounds of an element or not.
 * @param ref A reference to a JSX Element.
 * @param callback A function that is called when a User Action was preformed outside of the bounding box.
 * @param dep Values that this hook depends on.
 */
export const useTouchUpOutside = (ref: React.RefObject<HTMLElement>, callback: () => void = () => { }, dep?: React.DependencyList) => {
    useEffect(() => {
        function handleClickOutside(e: MouseEvent) {
            if (ref.current && !ref.current.contains(e.target as Node)) callback()
        }
        document.addEventListener("mousedown", handleClickOutside)
        return () => { document.removeEventListener("mousedown", handleClickOutside) }
    }, dep)
}